import type { AuthProviderProps } from 'react-oidc-context';
import { getRuntimeConfig } from '../runtimeConfig';

export function buildOidcConfig(): AuthProviderProps {
  const cfg = getRuntimeConfig();
  const appUrl = window.location.origin;
  return {
    authority: `${cfg.keycloakUrl}/realms/${cfg.keycloakRealm}`,
    client_id: cfg.keycloakClientId,
    redirect_uri: `${appUrl}/auth/callback`,
    post_logout_redirect_uri: appUrl,
    response_type: 'code',
    scope: 'openid profile email',
    automaticSilentRenew: true,
    loadUserInfo: true,
    onSigninCallback: (user) => {
      window.location.replace(returnPath(user?.state));
    },
  };
}

export function signinState(): { returnTo: string } {
  return { returnTo: `${window.location.pathname}${window.location.search}` };
}

export function returnPath(state: unknown): string {
  const returnTo =
    typeof state === 'object' && state !== null
      ? (state as { returnTo?: unknown }).returnTo
      : undefined;
  if (
    typeof returnTo !== 'string' ||
    !returnTo.startsWith('/') ||
    returnTo.startsWith('//') ||
    returnTo.startsWith('/\\') ||
    returnTo.startsWith('/auth/callback')
  ) {
    return '/';
  }
  return returnTo;
}

export function readAccessToken(): string | null {
  try {
    const cfg = getRuntimeConfig();
    const key = `oidc.user:${cfg.keycloakUrl}/realms/${cfg.keycloakRealm}:${cfg.keycloakClientId}`;
    const raw = sessionStorage.getItem(key);
    return raw
      ? ((JSON.parse(raw) as { access_token?: string }).access_token ?? null)
      : null;
  } catch {
    return null;
  }
}
